import { render, staticRenderFns } from "./SocialTooltip.vue?vue&type=template&id=584e94a8&scoped=true"
import script from "./SocialTooltip.vue?vue&type=script&lang=ts"
export * from "./SocialTooltip.vue?vue&type=script&lang=ts"
import style0 from "./SocialTooltip.vue?vue&type=style&index=0&id=584e94a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e94a8",
  null
  
)

export default component.exports